import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "ellipsis" }


import "element-plus/es/components/pagination/style/css";
import { ElPagination } from "element-plus";
import { useRoute, useRouter } from "vue-router";
import { usePageNumber } from "@/hooks";
export interface PageItem {
  title: string;
  releaseData: string;
  token: string;
}

export type PageList = PageItem[];
interface PagedListPorps {
  data: PageItem[];
  total: number;
  pageSize?: number;
  refresh: (page: number) => void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PagedList',
  props: {
    data: null,
    total: null,
    pageSize: null,
    refresh: null
  },
  setup(__props: any) {

const props = __props as {
  data: PageItem[];
  total: number;
  pageSize?: number;
  refresh: (page: number) => void;
}

const route = useRoute();


const router = useRouter();

const { pageNumber } = usePageNumber(props.refresh);

const setPageNumber = (value: number) => {
  if (route.name) {
    router.push({
      name: route.name,
      query: {
        pageNumber: value.toString(),
      },
    });
  }
};

const onRoute = (token: string) => {
  console.log(route.name?.toString());
  router.push({
    name: `${route.name!.toString()}-details`,
    params: {
      token,
    },
    query: route.query,
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("ul", {
      class: _normalizeClass(_ctx.$style.list)
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data, (item) => {
        return (_openBlock(), _createElementBlock("li", {
          key: item.token,
          onClick: ($event: any) => (onRoute(item.token))
        }, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(item.title), 1),
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.$style.datetime)
          }, _toDisplayString(item.releaseData), 3)
        ], 8, _hoisted_1))
      }), 128))
    ], 2),
    _withDirectives(_createVNode(_unref(ElPagination), {
      background: "",
      layout: "prev, pager, next",
      "prev-text": "上一页",
      "next-text": "下一页",
      total: __props.total,
      "page-size": 10,
      "current-page": _unref(pageNumber),
      "onUpdate:currentPage": setPageNumber
    }, null, 8, ["total", "current-page"]), [
      [_vShow, __props.data.length > 0]
    ])
  ]))
}
}

})